import { matchRouteParams } from './match-route';
import type { Route } from './routes';

// All workspace routes share this prefix. `satisfies Route` ties it to the
// canonical route list in routes.ts, so removing/renaming that route fails
// typecheck here rather than silently returning the wrong workspace id.
const WORKSPACE_ROUTE_PREFIX = '/workspaces/:workspaceId' satisfies Route;

/**
 * Extracts the raw `workspaceId` route segment from a pathname using the
 * canonical route pattern — i.e. what `useParams().workspaceId` used to return,
 * including the `last` sentinel and any id format the route accepts. Reads from
 * the pathname rather than route matches/params because the embedded-app router
 * bridge syncs the location without a TanStack Router load on same-bundle
 * navigations, leaving matches/params stale. (CON-7180)
 */
export function getWorkspaceIdParam(pathname: string): string | null {
  return matchRouteParams(pathname, WORKSPACE_ROUTE_PREFIX, { end: false })?.workspaceId ?? null;
}
